import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	withStyles,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	Typography,
	Tooltip,
	IconButton,
} from '@material-ui/core'
import { ExpandMore, Info } from '@material-ui/icons'
import classNames from 'classnames'
import styles from '../styles'
import { toggleVariablesPanel } from 'actions/template'
// import Variables from './Variables'
import Snippets from '../Snippets/Snippets'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return {
			variablesPanelExpanded: state.email.variablesPanelExpanded,
			snippetsPanelExpanded: state.email.snippetsPanelExpanded,
			disabled,
			// actionTypePanelExpanded: state.tasks.addOrEdit.actionTypePanelExpanded,
		}
	},
	(dispatch) => bindActionCreators({ toggleVariablesPanel }, dispatch),
)(
	withStyles(styles)(
		({
			classes,
			variablesPanelExpanded,
			toggleVariablesPanel,
			snippetsPanelExpanded,
			disabled,
		}) =>
			disabled ? null : (
				<ExpansionPanel
					style={
						variablesPanelExpanded || snippetsPanelExpanded
							? { borderRadius: 35, overflow: 'hidden', marginTop: 12 }
							: {
									borderBottomLeftRadius: 35,
									borderBottomRightRadius: 35,
									borderTopLeftRadius: 0,
									borderTopRightRadius: 0,
									overflow: 'hidden',
							  }
					}
					expanded={variablesPanelExpanded}
				>
					<ExpansionPanelSummary
						classes={{
							root: classes.expansionPanelSummary,
							expandIcon: classes.expandIcon,
						}}
						expandIcon={<ExpandMore />}
						onClick={() => toggleVariablesPanel()}
					>
						<Typography className={classes.heading}>
							{language.task.add.header.snippets}
						</Typography>
						<Tooltip title={language.task.add.toolTips.snippets}>
							<IconButton
								disableRipple
								style={{ padding: 0 }}
								className={classNames(classes.headingIcon, classes.color)}
							>
								<Info className={classes.icon} />
							</IconButton>
						</Tooltip>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails
					// className={classes.expansionPanelDetails}
					>
						<Snippets />
					</ExpansionPanelDetails>
				</ExpansionPanel>
			),
	),
)
